import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';

const PendingStatementsFailPage = ({ bankId }) => (
  <Content>
    {({
      pendingStatements3DPageTitle = '',
      pendingStatements3DSubheading1,
      pendingStatements3DContent,
      pendingStatements3DSubheading2,
      pendingStatementsContent1a,
      pendingStatementsDocumentsLinkTitle,
      pendingStatementsDocumentsLink,
      pendingStatementsContent1b,
      pendingStatementsBranchLinkTitle,
      pendingStatementsBranchLinkVM,
      pendingStatementsContent1c,
      pendingStatementsContent2,
      pendingStatementsContent3,
      closeWindow
    }) => (
      <StandardBody>
        <PageHeading>{pendingStatements3DPageTitle} </PageHeading>
        <SectionHeading>{pendingStatements3DSubheading1}</SectionHeading>
        <p>{pendingStatements3DContent}</p>
        <SectionHeading>{pendingStatements3DSubheading2}</SectionHeading>
        <p>
          {pendingStatementsContent1a}
          <WebsiteLink
            linkText={pendingStatementsDocumentsLinkTitle}
            url={pendingStatementsDocumentsLink}
            willOpenNewWindow
          />
          {pendingStatementsContent1b}
          <WebsiteLink
            linkText={pendingStatementsBranchLinkTitle}
            url={pendingStatementsBranchLinkVM}
            willOpenNewWindow
          />
          {pendingStatementsContent1c}
        </p>
        <p>{pendingStatementsContent2}</p>
        <p>{pendingStatementsContent3}</p>
        <p>
          <strong>{closeWindow}</strong>
        </p>
      </StandardBody>
    )}
  </Content>
);

PendingStatementsFailPage.propTypes = {
  bankId: PropTypes.bankId.isRequired
};

export default PendingStatementsFailPage;
